import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import type { FC } from 'react';
import React, { useState } from 'react';
import { delay } from 'lodash';
import Joi from 'joi';
import { useForm } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import type { DetailOtpRegisterFormInterface } from './register-container';
import { Button } from '~components/button';
import { ButtonColors } from '~constants/components';
import { Countdown } from '~components/widgets/countdown-widget';
import { Input } from '~components/input';
import type { UpdateApproveOtpAccountProps } from '~containers/profiles/approve-otp-account-container';

const ApproveOtpRegisterContainer: FC<{
  otpDetail: DetailOtpRegisterFormInterface;
  onSubmitForm: (values: { otp: string }) => void;
  onExpireOtp: () => void;
}> = (props) => {
  const { otpDetail, onSubmitForm, onExpireOtp } = props;
  const { t } = useTranslation(['forms', 'forgot-password']);
  const [loading, setLoading] = useState<boolean>(false);

  const schemaErrorsConfirmOtpForm = Joi.object({
    otp: Joi.string()
      .required()
      .length(6)
      .pattern(/^[0-9]+$/)
      .messages({
        'string.empty': t('forms:error-otp-empty'),
        'any.required': t('forms:error-otp-empty'),
        'string.length': t('forms:error-otp-fail'),
        'string.pattern.base': t('forms:error-otp-format'),
      }),
  }).unknown(true);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<UpdateApproveOtpAccountProps>({
    resolver: joiResolver(schemaErrorsConfirmOtpForm),
  });

  return (
    <div className="relative flex w-full flex-col gap-3">
      <form
        className="relative flex w-full flex-col gap-3"
        onSubmit={handleSubmit(onSubmitForm)}
      >
        <Input
          {...register('otp')}
          className="text-center"
          errors={errors.otp?.message ? [errors.otp.message] : undefined}
          placeholder={t('forms:place-holder-enter-otp')}
        />
        <p className="text-color text-center text-sm">
          ({t('forgot-password:otp-time-text')}{' '}
          <Countdown
            className="text-color-success font-semibold"
            onFinished={onExpireOtp}
            targetDate={dayjs(otpDetail.expiredAt).toDate()}
          />{' '}
          {t('forgot-password:minute-text')})
        </p>
        <Button
          color={ButtonColors.Primary}
          disabled={loading}
          loading={loading}
          onClick={() => {
            delay(() => {
              setLoading(false);
            }, 2000);
          }}
        >
          {t('buttons:btn-confirm-otp')}
        </Button>
      </form>
    </div>
  );
};

export default ApproveOtpRegisterContainer;
